import axios from 'axios';
import ConfigConnection from '../config/config.service';
export default class JobService{
  // API Instance
  configConnection: any = new ConfigConnection();

  get(pageOffset, itemsPerPage){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}job?offset=${pageOffset}&limit=${itemsPerPage}`, config);
  }

  create(job){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
        // 'Content-Type':  'multipart/form-data',
      }
    };
    console.log(job);
    return axios.post(`${_.configConnection.apiInstance}job`, job, config);
  }

  edit(job, idJob){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.put(`${_.configConnection.apiInstance}job/${idJob}`, job, config);
  }

  getById(idJob){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}job/${idJob}`, config);
  }

  delete_job(idJob){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.delete(`${_.configConnection.apiInstance}job/${idJob}`, config);
  }

  getCompanies(){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}company`, config);
  }

  getInactive(pageOffset, itemsPerPage){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}job/inactive?offset=${pageOffset}&limit=${itemsPerPage}`, config);
  }

  active_job(idJob, reactivate){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}job/${idJob}/reactivate`, config);
  }
}
